import { render, staticRenderFns } from "./intelligentRegulation.vue?vue&type=template&id=679f834c&scoped=true"
import script from "./intelligentRegulation.vue?vue&type=script&lang=js"
export * from "./intelligentRegulation.vue?vue&type=script&lang=js"
import style0 from "./intelligentRegulation.vue?vue&type=style&index=0&id=679f834c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679f834c",
  null
  
)

export default component.exports